import React, { useEffect, useState } from "react";
import { FileBarChart } from "lucide-react";
import api from "../api";

function Card({ children, className = "" }) {
  return <div className={`rounded-2xl border border-slate-200 bg-white p-5 shadow-sm md:p-6 ${className}`}>{children}</div>;
}

const COLORS = ["bg-emerald-500", "bg-amber-500", "bg-rose-500", "bg-slate-400"];

function BarBlock({ title, data }) {
  const max = Math.max(1, ...data.map((d) => d.value));
  return (
    <Card>
      <h2 className="text-base font-bold text-slate-900">{title}</h2>
      <div className="mt-4 space-y-3">
        {data.map((d, i) => (
          <div key={d.label}>
            <div className="mb-1 flex items-center justify-between text-sm"><span className="text-slate-600">{d.label}</span><span className="font-semibold text-slate-800">{d.value}</span></div>
            <div className="h-2.5 w-full overflow-hidden rounded-full bg-slate-100"><div className={`h-full rounded-full ${COLORS[i % COLORS.length]}`} style={{ width: `${(d.value / max) * 100}%` }} /></div>
          </div>
        ))}
      </div>
    </Card>
  );
}

export default function Reports() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/reports").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="text-sm text-slate-400">Loading reports…</div>;

  const stats = [
    { label: "Total profiles", value: data.total_profiles },
    { label: "Certified", value: data.certified },
    { label: "Client ready", value: data.client_ready },
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {stats.map((s) => (
          <Card key={s.label}>
            <div className="flex items-start justify-between"><span className="text-xs font-semibold uppercase tracking-wide text-slate-400">{s.label}</span><FileBarChart className="h-4 w-4 text-violet-500" /></div>
            <div className="mt-3 text-2xl font-bold text-slate-900">{s.value}</div>
          </Card>
        ))}
      </div>
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <BarBlock title="Documents by status" data={data.document_status} />
        <BarBlock title="Training progress distribution" data={data.training_distribution} />
      </div>
    </div>
  );
}
